import type { ElementType } from 'react';

import type { AiCoach_Action as AiCoachAction } from '__generated__/graphql-types';

import { Message, Snippet } from 'bundles/ai-course-coach/components/Conversation/components/Messages';
import { MESSAGES_TYPES, MESSAGE_SENDER } from 'bundles/ai-course-coach/components/constants';
import type { CreateUserMessageResultFragment } from 'bundles/ai-course-coach/queries/__generated__/aiCoachCreateUserMessageAndReturnResponseMutation';
import type {
  AiCoachRecommendedAction,
  CustomCompMessage,
  Feedback,
  Link,
  LinkParams,
  MessageTypes as MessageI,
} from 'bundles/ai-course-coach/store/types';

export function createNewMessage({
  text,
  sender,
  id,
  clipRecommendations,
  userFeedback,
  timestamp,
  recommendedActions,
  action,
  navigationButtons,
}: {
  text: string;
  sender: string;
  id?: string;
  clipRecommendations?: CreateUserMessageResultFragment['clipRecommendations'];
  userFeedback?: Feedback | null;
  timestamp?: string;
  recommendedActions?: AiCoachRecommendedAction;
  action?: AiCoachAction;
  navigationButtons?: CreateUserMessageResultFragment['navigationButtons'];
}): MessageI {
  return {
    type: MESSAGES_TYPES.TEXT,
    component: Message,
    text,
    sender,
    timestamp: timestamp ? new Date(timestamp) : new Date(),
    showAvatar: true,
    customId: id,
    unread: sender === MESSAGE_SENDER.RESPONSE,
    clipRecommendations,
    userFeedback,
    recommendedActions,
    action,
    navigationButtons,
  };
}

export function createLinkSnippet(link: LinkParams, id?: string): Link {
  return {
    type: MESSAGES_TYPES.SNIPPET.LINK,
    component: Snippet,
    title: link.title,
    link: link.link,
    target: link.target || '_blank',
    sender: MESSAGE_SENDER.RESPONSE,
    timestamp: new Date(),
    showAvatar: true,
    customId: id,
    unread: true,
  };
}

export function createComponentMessage(
  component: ElementType,
  props: any,
  showAvatar: boolean,
  id?: string
): CustomCompMessage {
  return {
    type: MESSAGES_TYPES.CUSTOM_COMPONENT,
    component,
    props,
    sender: MESSAGE_SENDER.RESPONSE,
    timestamp: new Date(),
    showAvatar,
    customId: id,
    unread: true,
  };
}
